import { useCallback, useEffect, useRef, useState } from 'react'

/** One toast at a time, 2.6 s (docs/UX-PLAYBOOK.md §5). Render `msg` inside a `.toast-slot[role=status]`. */
export function useToast(ms = 2600) {
  const [msg, setMsg] = useState('')
  const timer = useRef<ReturnType<typeof setTimeout>>(undefined)
  const show = useCallback(
    (text: string) => {
      clearTimeout(timer.current)
      setMsg(text)
      timer.current = setTimeout(() => setMsg(''), ms)
    },
    [ms],
  )
  useEffect(() => () => clearTimeout(timer.current), [])
  return [msg, show] as const
}
